import React from "react";

import { Rectangle } from "../../../../docuclipper/DocuclipperTypes";

import { connect } from "react-redux";
import { FormGroup, Form, FormControl, Row } from "react-bootstrap";
import PopoverHelp from "../../../Docuclipper/PopoverHelp";
import MultiButton from "../../../Docuclipper/MultiButton";

type Props = {
  updateRectangle: any;
};

type ReduxProps = {
  selectedRectangle: Rectangle;
  pageNumber: number;
};

export const RectanglePages: React.SFC<Props & ReduxProps> = ({
  selectedRectangle,
  updateRectangle,
  pageNumber,
}) => {
  // const [shouldApplyToAllPages, setShouldApplyToAllPages] = React.useState(
  //   false
  // );

  const parseItems = (s: string) => {
    const cleanS = s.replace(/ /g, "");
    return cleanS.split(",");
  };

  const areValidItems = (items: string[]) => {
    for (const item of items) {
      // if number or valid range return true
      const isNumber = !!item.match(/^\d+$/);
      const isRange = !!item.match(/^\d+\-\d+$/);
      if (!isNumber && !isRange) {
        return false;
      }
    }
    return true;
  };

  const handleIncludeChange = (what: "include" | "exclude") => (s: string) => {
    const items = parseItems(s);
    const valid = areValidItems(items);
    switch (what) {
      case "include":
        setIncludeStr(s);
        setIsValidInclude(valid);
        if (valid) {
          setInclude(items);
        }
        break;
      case "exclude":
        setExcludeStr(s);
        setIsValidExclude(valid);

        if (valid) {
          setExclude(items);
        }
        break;
    }
  };

  let selected;
  let defaultInclude: string[] = [];
  let defaultExclude: string[] = [];
  let defaultPagesOption: "all" | "current" | "include" | "exclude" = "all";

  if (selectedRectangle.vlocationEnabled) {
    selected = "All pages";
  } else {
    if ((selectedRectangle.includePages || []).length > 0) {
      selected = "Custom";
      defaultPagesOption = "include";
      defaultInclude = selectedRectangle.includePages;
      defaultExclude = [];
    } else if ((selectedRectangle.excludePages || []).length > 0) {
      selected = "Custom";
      defaultPagesOption = "exclude";
      defaultInclude = [];
      defaultExclude = selectedRectangle.excludePages;
    } else if (selectedRectangle.applyToAllPages) {
      selected = "All pages";
      defaultPagesOption = "all";
    } else {
      selected = `Page ${selectedRectangle.pageNumber + 1}`;
      defaultPagesOption = "current";
    }
  }

  const [pagesOption, setPagesOption] = React.useState<
    "all" | "current" | "include" | "exclude"
  >(defaultPagesOption);

  const [include, setInclude] = React.useState<string[]>(defaultInclude);
  const [exclude, setExclude] = React.useState<string[]>(defaultExclude);
  const [includeStr, setIncludeStr] = React.useState(defaultInclude.join(","));
  const [excludeStr, setExcludeStr] = React.useState(defaultExclude.join(","));

  const [isValidInclude, setIsValidInclude] = React.useState(
    areValidItems(defaultInclude)
  );
  const [isValidExclude, setIsValidExclude] = React.useState(
    areValidItems(defaultExclude)
  );

  const includeRef = React.useRef<any>(null);
  const excludeRef = React.useRef<any>(null);

  React.useEffect(() => {
    const includePages = pagesOption === "include" ? include : [];
    const excludePages = pagesOption === "exclude" ? exclude : [];
    updateRectangle(
      {
        id: selectedRectangle.id,
        applyToAllPages: ["all", "include", "exclude"].includes(pagesOption),
        includePages,
        excludePages,
      } as any,
      pageNumber
    );
  }, [pagesOption, include, exclude]);

  React.useEffect(() => {
    switch (pagesOption) {
      case "include":
        if (includeRef && includeRef.current) {
          includeRef.current.focus();
        }
        break;
      case "exclude":
        if (excludeRef && excludeRef.current) {
          excludeRef.current.focus();
        }
        break;
    }
  }, [pagesOption]);

  return (
    <>
      <MultiButton
        btnClassName=""
        selected={selected}
        onSelect={(option) => {
          const value = option.text;

          if (value === "All pages") {
            setPagesOption("all");
          } else if (value === "Custom") {
            setPagesOption("include");
            setInclude(["1"]);
            setIncludeStr("1");
            setExclude(["1"]);
            setExcludeStr("1");
          } else if (value === `Page ${selectedRectangle.pageNumber + 1}`) {
            setPagesOption("current");
          }
        }}
        options={[
          {
            text: `Page ${selectedRectangle.pageNumber + 1}`,
            apiName: `Page ${selectedRectangle.pageNumber + 1}`,
            icon: "" as any,
            disabled: selectedRectangle.vlocationEnabled,
          },
          {
            text: "All pages",
            apiName: "All pages",
            icon: "" as any,
            disabled: selectedRectangle.vlocationEnabled,
          },
          {
            text: "Custom",
            apiName: "Custom",
            icon: "" as any,
            disabled: selectedRectangle.vlocationEnabled,
          },
        ]}
      />

      {(pagesOption === "include" || pagesOption === "exclude") && (
        <div className="mt-2 ml-4">
          <FormGroup>
            <div className="mb-2">
              <FormGroup>
                <>
                  <Row>
                    <Form.Check
                      type="radio"
                      name="radio1"
                      value="include"
                      checked={pagesOption === "include"}
                      onChange={(e) =>
                        setPagesOption(e.target.value as "include")
                      }
                      label="Included pages"
                    />

                    <PopoverHelp
                      placement="right"
                      header=""
                      id="rectanglePagesIncludeHelp"
                    >
                      List of pages that have this field. Format is page numbers
                      and ranges separated by commas. E.g. <b>1,2-3,4</b>
                    </PopoverHelp>
                  </Row>
                </>
                {pagesOption === "include" && (
                  <>
                    <Form.Control
                      isInvalid={!isValidInclude || !includeStr}
                      name="includeStr"
                      value={includeStr}
                      placeholder="1,2-3,4"
                      onChange={(e) =>
                        handleIncludeChange("include")(
                          e.target.value as "include"
                        )
                      }
                      ref={includeRef}
                    ></Form.Control>
                    <FormControl.Feedback type="invalid">
                      Invalid pages. Format is page numbers and ranges separated
                      by commas. E.g. <b>1,2-3,4</b>
                    </FormControl.Feedback>
                  </>
                )}
              </FormGroup>
            </div>
            <div className="mb-2">
              <FormGroup>
                <>
                  <Row>
                    <Form.Check
                      className="mt-2"
                      type="radio"
                      name="radio1"
                      value="exclude"
                      checked={pagesOption === "exclude"}
                      onChange={(e) =>
                        setPagesOption(e.target.value as "exclude")
                      }
                      label="Excluded pages"
                    />

                    <PopoverHelp
                      placement="right"
                      header=""
                      id="rectanglePagesExcludeHelp"
                    >
                      List of pages that <b>don't</b> have this field. Format is
                      page numbers and ranges separated by commas. E.g.{" "}
                      <b>1,2-3,4</b>
                    </PopoverHelp>
                  </Row>
                </>
                {pagesOption === "exclude" && (
                  <>
                    <Form.Control
                      className="mt-2"
                      name="excludeStr"
                      placeholder="1,2-3,4"
                      isInvalid={!isValidExclude || !excludeStr}
                      ref={excludeRef}
                      value={excludeStr}
                      onChange={(e) =>
                        handleIncludeChange("exclude")(e.target.value)
                      }
                    ></Form.Control>
                    <FormControl.Feedback type="invalid">
                      Invalid pages. Format is page numbers and ranges separated
                      by commas. E.g. <b>1,2-3,4</b>
                    </FormControl.Feedback>
                  </>
                )}
              </FormGroup>
            </div>
          </FormGroup>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const page = state.Rectangles.selectedPage;
  const pageNumber = page ? page.pageNumber : -1;
  const selectedRectangle = state.Rectangles.selectedRectangle;
  const rectangles = state.Rectangles.rectangles;
  const maybeRectangles = (rectangles || []).filter(
    (r) => r.id === selectedRectangle
  );
  const rectangle = maybeRectangles.length > 0 ? maybeRectangles[0] : {};

  return {
    selectedRectangle: rectangle,
    pageNumber,
  };
};

export default connect(mapStateToProps, {})(RectanglePages);
